export default {
  install: (app) => {
    app.config.globalProperties.$hasAddOn = function (name) {
      return !!app.config.globalProperties.$page.props.website.add_on_instances.find((i) => i.add_on.uid === name)
    }
  },
}
